<template lang="html">
<div class="mt-3 sm:h-128">
  <div class="flex text-base justify-between">
    <div class="sm:w-auto w-full text-xl font-medium dark:text-white">
      Pinboard
    </div>
    <!-- Video takes folder selector -->
    <div class="flex space-x-3">
      <button class="underline px-4" @click="onDeleteState = !onDeleteState" v-if="!onDeleteState">Edit</button>
      <button class="text-indigo-600" @click="onDeleteState = !onDeleteState" v-if="onDeleteState">Cancel</button>
      <button class="px-4 btn btn-secondary" @click="showUploadItemModal = true;">Upload</button>
    </div>
  </div>
  <div class="overflow-none dark:bg-gray-900  border border-spacing-px dark:border-gray-800  bg-gray-50 rounded-lg shadow-inner p-2 h-full order-2 lg:order-2 mt-3">
    <transition-group name="slide-in" @before-leave="beforeLeave" tag="ul" class="grid my-0 px-0 py-0" :class="gridCount">
      <div :title="pi.name" v-for="(pi, i) in pinboardItems" v-bind:key="pi.id" class="relative opacity-80 hover:opacity-100 cursor-pointer" @click="showPreviewModal = true; selectedItem = i;">
        <li class="bg-gray-900 border border-spacing-px border-gray-800 slide-in-item col-span-1 aspect-square rounded-lg shadow overflow-hidden relative">
          <div v-if="pi.pinboard_item_type != null && pi.pinboard_item_type.includes('image')">
            <img :src="pi.url" class="absolute inset-0 z-1 object-cover w-full h-full transform">
          </div>
          <div v-else-if="pi.pinboard_item_type != null && pi.pinboard_item_type.includes('audio')">
          <div class="relative">
            <img class="absolute inset-0 z-1 object-cover w-full h-full transform">
            <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-1/2 text-white h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
              <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
            </svg>
          </div>
          </div>
          <div v-else-if="pi.pinboard_item_type != null && pi.pinboard_item_type.includes('video')">
            <div class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
            </svg>
          </div>
          </div>
          <div v-else class="relative bg-black">
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clip-rule="evenodd" />
            </svg>
          </div>
        </li>
        <div v-if="onDeleteState" class="absolute top-0 right-0 m-1">
          <button @click.stop.prevent="deletePinboardItem(pi.id)" class="btn bg-red-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    </transition-group>
  </div>
  <!-- Upload Pinboard Item Modal -->
  <modal :showModal="showUploadItemModal" @close="showUploadItemModal = false">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
      <!-- Upload cloud icon -->
      <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24">
        <path fill-rule="evenodd"
              d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
              clip-rule="evenodd"/>
      </svg>
    </div>
    <div class="mt-3 text-center sm:mt-5">
      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
        Upload a new Pinboard Item
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          Upload a new Item to the presentation pinboard.  The new item will be updated automatically.
        </p>
      </div>
    </div>
    <div class="mt-5">
      <label class="font-bold">Title</label>
      <label class="font-bold mt-2">Upload a file</label>
      <input type="file" ref="user_upload" class="form-input" id="takeName"
             v-on:change="handleFileUploaded($event)">
      <a v-show="fileNamePreview">{{fileNamePreview}}</a>
      <span v-show="fileSizeInvalid" class="text-red-600">The file you selected is larger than {{ fileLimitInMB }}MB.
        Please, upload files smaller than {{ fileLimitInMB }}MB to ensure a good experience.</span>
    </div>
    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
      <button type="button" class="btn sm:col-start-2 sm:text-sm" @click="uploadPinboardItem"
              :class="{'btn-primary': uploadMediaValidations, 'btn-disabled': !uploadMediaValidations}"
              :disabled="!uploadMediaValidations">
        Upload Item
      </button>
      <button type="button" class="btn btn-secondary"
              @click="showUploadItemModal = false;">
        Cancel
      </button>
    </div>
  </modal>
  <!-- Preview File Modal -->
  <modal :showModal="showPreviewModal" @close="handleClosePreview()" :class-size="'lg:max-w-4xl'">
    <div class="my-2 flex justify-between">
      <!-- Previous -->
      <button class="btn" :class="selectedItem <= 0 ? 'btn-disabled' : 'btn-primary'" :disabled="selectedItem <= 0" @click="selectedItem--"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
      <!-- show to everybody -->
      <template v-if="selectedPinboardItem !== null">
        <button v-if="selectedPinboardItem.pinboard_item_type.includes('image') || selectedPinboardItem.pinboard_item_type.includes('audio') || selectedPinboardItem.pinboard_item_type.includes('video')" class="btn" @click="presentPinboardItem()" v-show="isPresenter" :disabled="presentationMode" :class="presentationMode ? 'btn-disabled' : 'btn-primary'">
          {{ presentationMode ? 'Showing to everybody' : 'Show to everybody' }}
        </button>
        <button class="btn btn-secondary" @click="downloadPinboardItem()">Download</button>
      </template>
      <!-- Next -->
      <button class="btn" :class="selectedItem >= pinboardItems.length - 1? 'btn-disabled' : 'btn-primary'" :disabled="selectedItem == pinboardItems.length - 1" @click="selectedItem++"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/></svg></button>
    </div>
    <div v-if="selectedPinboardItem != null" class="h-auto w-auto">
      <div v-if="selectedPinboardItem.pinboard_item_type.includes('image')">
        <img class="w-full h-128 object-contain" :src="selectedPinboardItem.url">
        </div>
        <div v-else-if="selectedPinboardItem.pinboard_item_type.includes('audio')" class="h-full w-full">
          <div class="relative w-full bg-black" style="padding-bottom: 56.25%">
            <audio ref="content" :src="selectedPinboardItem.url" class="absolute w-full h-full object-contain p-2"></audio>
            <button id="tapToUnmuteButton" style="z-index: 70" type="button"
                class="flex items-center w-full absolute bottom-0 left-0 right-0 justify-center bg-red-500 cursor-pointer hover:bg-red-600 hidden">
                <div class="z-10 text-white text-xl font-bold text-center">
                  Tap here to unmute video
                </div>
              </button>
          </div>
        </div>
        <div v-else-if="selectedPinboardItem.pinboard_item_type.includes('video')">
          <div class="relative w-full bg-black" style="padding-bottom: 56.25%">
            <video ref="content" :src="selectedPinboardItem.url" class="absolute w-full h-full object-contain"></video>
            <button id="tapToUnmuteButton" style="z-index: 70" type="button"
                class="flex items-center w-full absolute bottom-0 left-0 right-0 justify-center bg-red-500 cursor-pointer hover:bg-red-600 hidden">
                <div class="z-10 text-white text-xl font-bold text-center">
                  Tap here to unmute video
                </div>
              </button>
          </div>
        </div>
        <div v-else>
          <div>We cannot preview or publish this type of file</div>
          <a type="button" :href="selectedPinboardItem.url" download class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Download
          </a>
        </div>
      </div>
    <div class="text-base font-italic text-gray-600 text-center mt-5" v-if="selectedPinboardItem != null">{{selectedPinboardItem.name}}</div>
    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import commandsManager from 'general/CommandsManager'
import { detectBrowser } from 'utils/browser';

export default {
  name: 'pinboard',
  props: ['presentationId', 'pKey', 'role', "gridCount"], // Note: pKey can be either from a room or a participant
  data(){
    return {
      pinboardItems: [],
      showUploadItemModal: false,
      fileSizeInvalid: false,
      fileLimitInMB: 20,
      fileNamePreview: null,
      onDeleteState: false,
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      formData: {
        type: FormData
      },
      showPreviewModal: false,
      selectedItem: -1,
      showLightbox: false,
      presentationMode:false,
      isPresenter: this.role === 'host' || this.role === 'presenter',
      presentedPinboardItem: null,
      isSafari: false,
    }
  },
  methods: {
    downloadPinboardItem(){
      window.open(this.selectedPinboardItem.url, '_blank');
    },
    showPinboardItem(pi){
      this.renderPinboardItemLightbox(pi);
    },
    presentPinboardItem(){
      this.presentationMode = true;
      commandsManager.sendAllCommand('show_pinboard_item', { pinboardItem: this.selectedPinboardItem } );
      this.setupListeners();
    },
    renderPinboardItemLightbox(pi) {
      this.presentedPinboardItem = pi;
      this.showPreviewModal = true

    },
    hidePinboards(){
      this.presentedPinboardItem = null;
      this.showPreviewModal = false;
    },
    fileSizeIsValid(file) {
      return file.size / 1024 / 1024 <= this.fileLimitInMB;
    },
    loadPinboardItems(){
      axios.get('/presentation/'+ this.pKey +'/pinboard_items?role='+this.role).then((response) => {
        this.pinboardItems = response.data;
      }).catch(err => {
        this.pinboardItems = [];
      });
    },
    beforeLeave(el) {
      const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    },
    uploadPinboardItem(){
      if(!this.uploadMediaValidations) return;

      let file = this.$refs.user_upload.files[0];
      if(this.fileSizeIsValid(file) == false) return;

      let url = '/presentation/'+ this.pKey +'/pinboard_items?role='+this.role;
      this.formData = new FormData();
      this.formData.append('pinboard_item_type', file.type);
      this.formData.append('file', file);
      this.formData.append('name', file.name)
      this.formData.append('authenticity_token', this.token);

      axios.post(url, this.formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(response => {
        this.showUploadItemModal = false;
        this.loadPinboardItems();
        this.fileNamePreview = "";
        this.$refs.user_upload.value = ""
        commandsManager.sendAllCommand('reload_pinboard');
      }).catch(err => {

      })
    },
    handleFileUploaded(event){
      if(event.target.files.length == 0){
        this.fileNamePreview = null;
        return;
      }
      let file = event.target.files[0];
      this.fileSizeInvalid = !this.fileSizeIsValid(file);
      if(this.fileSizeInvalid) {
        this.fileNamePreview = null;
        return;
      }
      this.fileNamePreview = file.name;
    },
    deletePinboardItem(pinboardItemId){
      axios.delete('/pinboard_item/'+pinboardItemId+ '?key=' + this.pKey+'&role='+this.role, {
        headers: {
          'X-CSRF-Token': this.token
        }
      }).then(response => {
        this.loadPinboardItems();
        commandsManager.sendAllCommand('reload_pinboard');
      }).catch(response => {

      })
    },
    handleClosePreview(){
      this.showPreviewModal = false;
      if(this.selectedPinboardItem.pinboard_item_type.includes('audio') ||
         this.selectedPinboardItem.pinboard_item_type.includes('video')){
        this.$refs.content.pause();
      }

      if(this.presentationMode == true){
        commandsManager.sendAllCommand('hide_pinboard_items');
      }
      this.presentationMode = false;
      //this.selectedItem = -1;
    },
    setupListeners(){
      // add listeners if its a video or a audio
      window.setTimeout(() => {
        if (this.$refs.content){
          // console.log("setting listeners")
          this.$refs.content.onplay = () => {
            console.log("play listeners")
            commandsManager.sendAllCommand('play_pinboard_item', { currentTime: this.$refs.content.currentTime } );
          }
          this.$refs.content.onseeking = () => {
            commandsManager.sendAllCommand('seek_pinboard_item', { currentTime: this.$refs.content.currentTime } );
          };
          this.$refs.content.onpause = () => {
            commandsManager.sendAllCommand('pause_pinboard_item', { currentTime: this.$refs.content.currentTime } );
          }
        }
      }, 100)

    }
  },
  mounted(){
    const browser = detectBrowser(window);
    this.isSafari = browser.browser === 'safari' && browser.version >= 605 && (browser.iphone || browser.ipad);

    this.loadPinboardItems();
    commandsManager.registerNewCommand('reload_pinboard', () => {
        this.loadPinboardItems();
      });
    commandsManager
      .registerNewCommand('show_pinboard_item', (data) => {
        // setup tap to unmute for safari

        window.setTimeout(()=>{
        if (this.isSafari && this.$refs.content) {
            this.$refs.content.muted = true;
            let tapToUnmuteButton = document.querySelector('#tapToUnmuteButton');
            if (tapToUnmuteButton) {
              tapToUnmuteButton.classList.remove('hidden');
              tapToUnmuteButton.onclick = () => {
                this.$refs.content.muted = false;
                tapToUnmuteButton.classList.add('hidden');
              };
            }
          }

        }, 1000)
        this.showPinboardItem(data.args.pinboardItem);
      })
      .registerNewCommand('play_pinboard_item', (data) => {
          this.$refs.content.currentTime = data.args.currentTime;
          this.$refs.content.play()
      })
      .registerNewCommand('pause_pinboard_item', () => {
          this.$refs.content.pause()
      })
      .registerNewCommand('seek_pinboard_item', (data) => {
          this.$refs.content.currentTime = data.args.currentTime;
      })
      .registerNewCommand('hide_pinboard_items', () => {
        this.hidePinboards();
      })
  },
  watch: {
    selectedItem(){
      if (this.presentationMode == true){
        commandsManager.sendAllCommand('show_pinboard_item', { pinboardItem: this.selectedPinboardItem } );
        this.setupListeners();
    }
      }
  },
  computed: {
    uploadMediaValidations(){
      return !this.fileSizeInvalid;
    },
    selectedPinboardItem(){
      if(this.presentedPinboardItem === null){
        return this.selectedItem > -1 ? this.pinboardItems[this.selectedItem] : null;
      }else{
        return this.presentedPinboardItem;
      }
    }
  }
}
</script>
